<div class="dialog-container">
  <div class="dialog-header">
    <div>
      <div class="dialog-header-title">
        {{
          (isFCChangePaymentMethod
            ? 'SETTLE_BILL.CHANGE_PMT_METHOD'
            : 'SETTLE_BILL.PAYMENT_PENDING'
          ) | fallbackTranslate
        }}
      </div>
      <div
        class="fs-16 fw-400 clr-333"
        *ngIf="billingCounterName"
        [innerHTML]="billingCounterInfo"
      ></div>
    </div>
    <div class="dialog-header-cross" (click)="cancel_clicked()">
      <img [src]="images.CROSS" class="img-20" alt="close" />
    </div>
  </div>

  <div class="dialog-form">
    <div *ngIf="!isFCChangePaymentMethod" class="fs-14 fw-600 clr-333 p-l-16 p-t-16 p-b-16 p-r-16">
      {{ 'SETTLE_BILL.PAYMENT_OF' | fallbackTranslate }} {{ Currency }}
      {{ format.formatNo(billAmount) }}
      {{ 'SETTLE_BILL.IS_PENDING_FOR_ORDER' | fallbackTranslate }} #{{
        orderNo
      }}.
    </div>

    <app-payment-options
      #paymentOptionComponent
      [showUnionExperience]="data?.showUnionExperience"
      [showQris]="data.showQris"
      [showDuitnow]="!isFCChangePaymentMethod && data.showDuitnow"
      [showPineLab]="!isFCChangePaymentMethod && data.showPineLab"
      [amount]="
        isFCChangePaymentMethod && fcOrderPayments?.length
          ? fcOrderPayments[0]?.paid_total
          : this.billAmount
      "
      [platform]="this.platform"
      (name)="paymentName($event)"
      (channel)="paymentChannel($event)"
      (t_id)="transactionIdChange($event)"
      (amount_paid)="amountPaid($event)"
      (cashDetails)="cashTransactionDetail($event)"
      [paymentInputDisabled]="isPaymentAmountInputDisabled"
      [isFCChangePaymentMethod]="isFCChangePaymentMethod"
      [orderId]="orderId"
      [fcOrderPayments]="fcOrderPayments"
    ></app-payment-options>
  </div>
  <div class="payment-btn-wrapper">
    <button
      class="wd-100 fw-600 fs-16"
      nz-button
      nzSize="large"
      (click)="paymentDoneClicked()"
      [disabled]="
        isFCChangePaymentMethod
          ? !currentPaymentChannel
          : !(currentPaymentChannel && billAmount > 0)
      "
    >
      {{ 'SETTLE_BILL.COLLECT_PAYMENT' | fallbackTranslate }}
    </button>
  </div>
</div>
